import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const notificationDescriptions = {
    emailNotifications: 'Receive notifications via email',
    pushNotifications: 'Receive push notifications in your browser',
    documentProcessing: 'Notifications when documents finish processing',
    systemUpdates: 'Updates about new features and system changes',
    securityAlerts: 'Important security and account alerts'
};
export function NotificationSettings({ notifications, onNotificationChange }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "space-y-6",
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text-lg font-medium text-foreground mb-4",
                    children: "Notification Preferences"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "space-y-4",
                    children: Object.entries(notifications).map(([key, value])=>/*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("label", {
                                            className: "text-sm font-medium text-foreground capitalize",
                                            children: key.replace(/([A-Z])/g, ' $1').toLowerCase()
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "text-sm text-muted-foreground",
                                            children: notificationDescriptions[key]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: ()=>onNotificationChange(key),
                                    className: `relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${value ? 'bg-primary' : 'bg-muted'}`,
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: `inline-block h-4 w-4 transform rounded-full bg-card transition-transform ${value ? 'translate-x-6' : 'translate-x-1'}`
                                    })
                                })
                            ]
                        }, key))
                })
            ]
        })
    });
}
